var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.60004V5.60967M8.5 10.8165V10.8428M12.28 13.3334H4.72005C3.6874 13.3334 2.81595 12.6509 2.54177 11.7172C2.42473 11.3186 2.56854 10.9034 2.78851 10.5499L6.56846 3.73404C7.45407 2.3109 9.54594 2.3109 10.4315 3.73404L14.2115 10.5499C14.4315 10.9034 14.5753 11.3186 14.4582 11.7172C14.1841 12.6509 13.3126 13.3334 12.28 13.3334Z",
    stroke: "#CB1A14",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/Alert-triangle.6894332401b3d530ef92a6ee3ffcce11.svg";
export { ForwardRef as ReactComponent };